import styled from "styled-components";

export const CardStyled = styled.div`
  max-width: 560px;
  margin: 24px;
  background: #fff;
  border: 1px solid ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
  border-radius: 8px;
  padding: 24px 28px;
`;

export const FieldBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 22px;
`;

export const CurrentRoleRowStyled = styled.div`
  font-size: 13px;
  color: ${(p) => p.theme?.colors?.textSecondary ?? "#5A6A7A"};
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${(p) => p.theme?.colors?.borderLight ?? "#E5E7EB"};
  strong {
    color: ${(p) => p.theme?.colors?.dark ?? "#2B3034"};
  }
`;

export const RadioRowStyled = styled.div`
  .ant-radio-group {
    display: flex;
    gap: 24px;
  }
`;
